(function($){
    var $fn = $(".comp_long_page");

    if($fn.length){
        var $slider = $fn.find("[data-slider]"),
            $slider_caption = $fn.find("[data-slider-caption]"),
            $nav = $fn.find(".wrp_slider_nav"),
            $side_nav = $fn.find(".wrp_side_nav");

        $side_nav.stick_in_parent({
            offset_top: 120
        });

        $fn.find(".mod--section").each(function(index) {
            var $this = $(this),
                $position = $this.position(),
                $nav_item = $side_nav.find("[href=\"#"+$this.data("anchor-elm")+"\"]");

            $this.scrollspy({
                min: $position.top,
                max: $position.top + $this.height(),
                onEnter: function onEnter() {
                    $nav_item.addClass("mod--active");
                },
                onLeave: function onLeave() {
                    $nav_item.removeClass("mod--active");
                }
            });
        });

        if($slider.children().length > 1){
            $slider.slick({
                accessibility: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: true,
                dots: false,
                asNavFor: $slider_caption,
                prevArrow: "<i class=\"icon--previous slick-prev\"></i>",
                nextArrow: "<i class=\"icon--next slick-next\"></i>",
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 481,
                        settings: {
                            arrows: true,
                            dots:false,
                            prevArrow: "<i class=\"icon--previous slick-prev\"></i>",
                            nextArrow: "<i class=\"icon--next slick-next\"></i>"
                        }
                    }
                ]
            });
            $slider_caption.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: false,
                dots: false,
                accessibility: false,
                draggable: false,
                swipe:false,
                asNavFor: $slider
            });

            $slider.on('afterChange', function(event, slick, currentSlide){
                $nav.find(".mod--active").removeClass("mod--active");
                $nav.find("[data-index="+currentSlide+"]").addClass("mod--active");
            });

            $fn.on("click",".wrp_slider_nav [data-index]",function () {
                var $this = $(this),
                    $index = $this.data("index");
                if(!$this.hasClass("mod--active")){
                    $nav.find(".mod--active").removeClass("mod--active");
                    $this.addClass("mod--active");
                    $slider.slick("slickGoTo",$index);
                }
            })
        }
    }
})(jQuery);